import * as React from 'react';
export var Multiply = function () {
    return React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-hidden": "true" },
        React.createElement("path", { d: "M17.613 8.258a1.323 1.323 0 1 0-1.871-1.87L12 10.128 8.258 6.387a1.323 1.323 0 1 0-1.87 1.871L10.128 12l-3.742 3.742a1.323 1.323 0 1 0 1.871 1.87L12 13.872l3.742 3.742a1.323 1.323 0 1 0 1.87-1.871L13.872 12z", fill: "currentColor" }));
};
